import { css } from 'emotion';

import { colors, fonts } from '../../styles';

export const underlinedInput = {
  root: {
    height: '100%',
    padding: 0,
    border: 'none',
    borderBottom: `1px solid ${colors.gray.default}`,

    '&[class*=-error][class*=-focused]': {
      boxShadow: 'none',
    },
  },
  focused: {
    borderColor: colors.black,
    boxShadow: 'none',
  },
  input: {
    color: colors.gray.dark,
  },
};

export const wrapper = css`
  position: relative;
`;

export const icon = css`
  flex-shrink: 0;

  height: 16px;
  width: 16px;
  margin-right: 10px;

  color: ${colors.gray.default};
`;

export const input = css`
  width: 100%;
  text-overflow: ellipsis;
`;

export const optimizedInput = css`
  display: flex;
  width: 100%;
  text-overflow: ellipsis;
  height: 30px;
  padding: 0;
  border: none;
  border-bottom: 1px solid ${colors.gray.default};

  :focus-within {
    border-color: ${colors.black};
    box-shadow: none;
  }

  input {
    box-shadow: none;
    width: 100%;
    border: none;
    font-size: ${fonts.size.small};
    font-weight: ${fonts.weight.regular};
    color: ${colors.black};
    padding: unset;
    text-overflow: ellipsis;
    background: none;

    &::placeholder {
      opacity: 1;
      color: ${colors.gray.dark};
      font-weight: ${fonts.weight.light};
    }
  }
`;

export const inputArea = css`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const optimizedInputError = css`
  ${optimizedInput};
  border-bottom: 1px solid ${colors.error.default};
`;

export const list = css`
  list-style: none;

  top: 42px;
  left: 0;
  position: absolute;

  width: 300px;
  padding: 0;
  margin: 0;
  z-index: 999999;

  background-color: ${colors.white};
  cursor: pointer;
`;

export const suggestion = css`
  display: flex;
  align-items: center;

  color: ${colors.black};
  font-size: ${fonts.size.small};
  font-weight: ${fonts.weight.regular};

  border: 1px solid ${colors.gray.light};
  border-top: none;

  padding: 0 20px 0 10px;
  height: 40px;
  z-index: 999999;
`;

export const active = css`
  background-color: ${colors.gray.lightest};
`;

export const description = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
